import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex align-items-start" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left mr-1" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_4 = { class: "ml-auto d-flex align-items-center" }
const _hoisted_5 = {
  key: 0,
  class: "label-error mt-1"
}
const _hoisted_6 = { class: "text-danger" }
const _hoisted_7 = {
  key: 0,
  class: "text-center empty-state",
  style: {"margin":"10%"}
}
const _hoisted_8 = { class: "text-gray mt-5" }
const _hoisted_9 = { class: "floor-title form-custom" }
const _hoisted_10 = /*#__PURE__*/_createVNode("hr", { class: "hr apartments-section" }, null, -1)
const _hoisted_11 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Divider = _resolveComponent("Divider")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_RiserItem = _resolveComponent("RiserItem")
  const _component_InputText = _resolveComponent("InputText")
  const _component_ApartmentItem = _resolveComponent("ApartmentItem")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_ScrollableTabView = _resolveComponent("ScrollableTabView")
  const _component_DialogAddEditBuilding = _resolveComponent("DialogAddEditBuilding")
  const _component_DialogAddEditApartment = _resolveComponent("DialogAddEditApartment")
  const _component_DialogAddRiser = _resolveComponent("DialogAddRiser")
  const _component_DialogEditRiser = _resolveComponent("DialogEditRiser")
  const _component_DialogConfirmDelete = _resolveComponent("DialogConfirmDelete")
  const _component_DialogCreateBackbone = _resolveComponent("DialogCreateBackbone")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", null, [
          _createVNode(_component_router_link, {
            to: _ctx.backLink,
            class: "fs-18 text-decoration-none text-gray"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("general.backTo")) + ": " + _toDisplayString(_ctx.$t("AppResourceEP.Structure")), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          (_ctx.building)
            ? (_openBlock(), _createBlock("h1", _hoisted_3, _toDisplayString(_ctx.building.name), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Divider, { layout: "vertical" }),
          _createVNode(_component_ElDropdown, {
            trigger: "click",
            placement: "bottom-end",
            "popper-class": "el-dropdown__popper el-dropdown--context"
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                default: _withCtx(() => [
                  (_ctx.currentEntrancePlant.hasRiserInterface && _ctx.noBackboneInterface)
                    ? (_openBlock(), _createBlock(_component_ElDropdownItem, {
                        key: 0,
                        onClick: _ctx.toggleCreateBackboneInterface
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("AppResourceEP.CreateBackbone")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.currentEntrancePlant.hasRiserInterface)
                    ? (_openBlock(), _createBlock(_component_ElDropdownItem, {
                        key: 1,
                        onClick: _ctx.toggleAddRiser
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("AppResourceEP.AddRisers")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (!_ctx.currentEntrancePlant.hasRiserInterface)
                    ? (_openBlock(), _createBlock(_component_ElDropdownItem, {
                        key: 2,
                        onClick: _ctx.toggleAddApartment,
                        disabled: !_ctx.apartmentsAvailable,
                        style: {"display":"block"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("AppResourceEP.AddApartments")) + " ", 1),
                          (!_ctx.apartmentsAvailable)
                            ? (_openBlock(), _createBlock("label", _hoisted_5, _toDisplayString(_ctx.$t('entrancePlant.apartmentLimitReached', { maxApartments: 3999 })), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ElDropdownItem, { onClick: _ctx.toggleAddEditBuilding }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("AppResourceEP.Rename")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_ElDropdownItem, { onClick: _ctx.toggleDeleteBuildingConfirm }, {
                    default: _withCtx(() => [
                      _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Button, { class: "p-button-text p-button-secondary p-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_InlineSvgScoped, {
                    src: 
                                require('@/assets/images/icons/icon-ellipsis-v.svg')
                            ,
                    "aria-label": "icon-ellipsis-v"
                  }, null, 8, ["src"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (_ctx.currentEntrancePlant.hasRiserInterface)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (_ctx.buildingStructure.length == 0)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t("entrancePlant.nothingHere")), 1)
              ]))
            : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.buildingStructure, (riserStructure, index) => {
                return (_openBlock(), _createBlock(_component_RiserItem, {
                  class: "building-card mt-3",
                  key: index,
                  riserStructure: riserStructure,
                  onClick: ($event: any) => (_ctx.goToRiser(riserStructure.riser))
                }, null, 8, ["riserStructure", "onClick"]))
              }), 128))
        ], 64))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          (
                _ctx.currentEntrancePlant.addressingType ==
                _ctx.AddressingType.BuildingRiserFloorApartment
            )
            ? (_openBlock(), _createBlock(_component_ScrollableTabView, {
                key: 0,
                scrollable: "",
                class: "p-tabview--custom tab-riser-select mb-2 gray-back"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildingStructure, (riserTab, riserIndex) => {
                    return (_openBlock(), _createBlock(_component_TabPanel, {
                      key: riserIndex,
                      header: riserTab.riser.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ElScrollbar, { class: "apartments-cards-list__brfa" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(riserTab.floors, (floorsection, floorIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                key: floorIndex,
                                class: "mb-5"
                              }, [
                                _createVNode("div", _hoisted_9, [
                                  _createVNode(_component_InputText, {
                                    class: "fs-18 text-gray text-uppercase ml-3",
                                    modelValue: floorsection.floor.name,
                                    "onUpdate:modelValue": ($event: any) => (
                                        _ctx.verifyValidityOfName(
                                            $event,
                                            floorsection.floor
                                        )
                                    )
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                  _hoisted_10
                                ]),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(floorsection.apartments, (apartment, apartmentIndex) => {
                                  return (_openBlock(), _createBlock(_component_ApartmentItem, {
                                    class: "apartment-card",
                                    key: apartmentIndex,
                                    apartment: apartment,
                                    onEditApartment: _ctx.toggleEditApartment,
                                    onDeleteApartment: _ctx.toggleDeleteApartment
                                  }, null, 8, ["apartment", "onEditApartment", "onDeleteApartment"]))
                                }), 128))
                              ]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["header"]))
                  }), 128))
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_ElScrollbar, {
                key: 1,
                class: "apartments-cards-list"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_11, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.apartments, (apartment, index) => {
                      return (_openBlock(), _createBlock(_component_ApartmentItem, {
                        class: "apartment-card",
                        key: index,
                        apartment: apartment,
                        onEditApartment: _ctx.toggleEditApartment,
                        onDeleteApartment: _ctx.toggleDeleteApartment
                      }, null, 8, ["apartment", "onEditApartment", "onDeleteApartment"]))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
        ], 64)),
    _createVNode(_component_DialogAddEditBuilding, {
      isVisible: _ctx.isVisibleAddEditBuilding,
      buildingToEdit: _ctx.building,
      onHideDialog: _ctx.toggleAddEditBuilding,
      onUpdateList: _ctx.handleUpdateList
    }, null, 8, ["isVisible", "buildingToEdit", "onHideDialog", "onUpdateList"]),
    _createVNode(_component_DialogAddEditApartment, {
      building: _ctx.building,
      isVisible: _ctx.isVisibleAddEditApartment,
      apartmentToEdit: _ctx.apartmentToEdit,
      onHideDialog: _ctx.hideAddEditApartment,
      onUpdateList: _ctx.handleUpdateList
    }, null, 8, ["building", "isVisible", "apartmentToEdit", "onHideDialog", "onUpdateList"]),
    _createVNode(_component_DialogAddRiser, {
      building: _ctx.building,
      isVisible: _ctx.isVisibleAddRiser,
      onHideDialog: _ctx.hideAddRiser,
      onUpdateList: _ctx.handleUpdateList,
      onRisersCreated: _ctx.handleRisersCreated
    }, null, 8, ["building", "isVisible", "onHideDialog", "onUpdateList", "onRisersCreated"]),
    _createVNode(_component_DialogEditRiser, {
      building: _ctx.building,
      isVisible: _ctx.isVisibleEditRiser,
      riserToEdit: _ctx.currentRiserToEdit,
      isNewRiser: "",
      onHideDialog: _ctx.hideEditRiser,
      onUpdateList: _ctx.handleUpdateList
    }, null, 8, ["building", "isVisible", "riserToEdit", "onHideDialog", "onUpdateList"]),
    _createVNode(_component_DialogConfirmDelete, {
      "is-visible": _ctx.isVisibleDeleteBuildingConfirm,
      title: _ctx.$t('AppResourceEP.BuildingDeletionPopupTitle'),
      message: _ctx.$t('AppResourceEP.BuildingDeletionPopupMessage'),
      onHideDialog: _ctx.toggleDeleteBuildingConfirm,
      onConfirm: _ctx.handleDeleteBuilding
    }, null, 8, ["is-visible", "title", "message", "onHideDialog", "onConfirm"]),
    _createVNode(_component_DialogConfirmDelete, {
      "is-visible": _ctx.isVisibleDeleteApartmentConfirm,
      title: _ctx.$t('AppResourceEP.ApartmentDeletionPopupTitle'),
      message: _ctx.$t('AppResourceEP.ApartmentDeletionPopupMessage'),
      onHideDialog: _ctx.toggleDeleteApartment,
      onConfirm: _ctx.handleDeleteApartment
    }, null, 8, ["is-visible", "title", "message", "onHideDialog", "onConfirm"]),
    _createVNode(_component_DialogCreateBackbone, {
      isVisible: _ctx.isVisibleCreateBackboneInterface,
      building: _ctx.building,
      onHideDialog: _ctx.hideCreateBackboneInterface,
      onUpdateList: _ctx.handleUpdateList
    }, null, 8, ["isVisible", "building", "onHideDialog", "onUpdateList"])
  ], 64))
}